import React from 'react'
import { OrderFormContext, OrderFormContextProvider } from './OrderFormContext'
import { ProductListContext, ProductListContextProvider } from './ProductListContext'
import { ProductionProgressContext, ProductionProgressContextProvider } from './ProductionProgressContext'


const withOrderFormContext = (propsSetup) => {
  return Component => () => (
    <OrderFormContext.Consumer>
      {context => <Component {...propsSetup(context)} context={context} />}
    </OrderFormContext.Consumer>
  )
}

const withProductListContext = (propsSetup) => {
  return Component => () => (
    <ProductListContext.Consumer>
      {context => <Component {...propsSetup(context)} context={context} />}
    </ProductListContext.Consumer>
  )
}

const withProductionProgressContext = (propsSetup) => {
  return Component => () => (
    <ProductionProgressContext.Consumer>
      {context => <Component {...propsSetup(context)} context={context}/>}
    </ProductionProgressContext.Consumer>
  )
}

export {
  OrderFormContext,
  OrderFormContextProvider,
  withOrderFormContext,
  ProductListContext,
  ProductListContextProvider,
  withProductListContext,
  ProductionProgressContext,
  ProductionProgressContextProvider,
  withProductionProgressContext,
}
